<template>
  <div class="ms2_product catalog-item catalog-item--list">
    <form method="post" class="ms2_form"><input type="hidden" name="id" :value="item.article" />
      <input type="hidden" name="count" :id="'count_' + item.article" :value="count"/>
      <input type="hidden" name="options" value="[]" />
      <a class="catalog-item__link" :href="'/catalog/item?id=' + item.article" :alt="item.pagetitle" :title="item.pagetitle">
        <div class="catalog-item__image">
          <img class="catalog-item__picture" v-lazy="'/data/images/' + item.article.slice(0, -4) + '/' + item.article + '.jpg'" :alt="item.pagetitle"/>
          <div class="catalog-item__labels">
            <div class="catalog-item__tag catalog-item__hit" v-if="item.popular">Хит</div>
          </div>
        </div>
        <div class="catalog-item__price">
          <div class="catalog-item__price-val">{{ item.price || "0" }} р.</div>
          <div class="catalog-item__price-old"></div>
        </div>
        <div class="catalog-item__title">
          <p>{{ item.pagetitle }}</p>
        </div>
        <div class="catalog-item__cost" :title="item.vendor">{{ item.vendor }}</div>
        <div class="catalog-item__quantity">{{ parseInt(item.quantity) ? "В наличии" : "Нет в наличии" }}</div>
      </a>
      <div class="catalog-item__checker">
        <div class="input-group input-group-sm">
          <div class="input-group-prepend">
            <button style="min-width: 2.5rem" class="btn btn-decrement btn-outline-secondary" type="button" @click="count--">
              <strong>-</strong>
            </button>
          </div>
          <input type="text" style="text-align: center" :data-id="item.article" class="form-control" placeholder="" :value="count" @input="count = $event.target.value"/>
          <div class="input-group-append">
              <button style="min-width: 2.5rem" class="btn btn-increment btn-outline-secondary" type="button" @click="count++">
              <strong>+</strong>
            </button>
          </div>
        </div>
      </div>
      <button class="btn btn-outline-secondary b-hover" type="submit" name="ms2_action" value="cart/add">Добавить в корзину</button>
    </form>
  </div>
</template>
<script>
export default {
  name: 'Card',
  props: ['item'],
  data () {
    return {
      count: 1
    }
  }
}
</script>
